import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import Dot from './dot';

import colors from './colors';
import Checkbox from 'antd/lib/checkbox/Checkbox';

const Option = Select.Option;

const ALL_OPTION = { label: 'All', value: 'all' };

const allSelected = (value = []) => value.includes('all');

const getAllOptValue = (options = []) =>
  [ALL_OPTION, ...options].map((item = {}) => item.value);

const renderOptions = (options = [], selected = [], hasDot) => {
  const opts = options.length > 0 ? [ALL_OPTION, ...options] : options;

  return opts.map((opt, i) => (
    <Option
      key={`dd-multiple-select-${opt.value}`}
      value={opt.value}
      className="dd-multiple-select-option"
    >
      {hasDot && (
        <Dot
          color={opt.value === 'all' ? 'transparent' : colors[opt.value - 1]}
        />
      )}
      {opt.label}
      <Checkbox
        checked={selected.includes(opt.value)}
        className="dd-multiple-select-checkbox"
      />
    </Option>
  ));
};

const getShowValue = (selected = [], options = []) => {
  if (selected.length === 0) {
    return '';
  }

  if (allSelected(selected)) {
    return 'All';
  }

  return options
    .filter((opt) => selected.includes(opt.value))
    .map((opt) => opt.label)
    .join(',');
};
function MulipleSelect(props) {
  const [selected, changeSelected] = useState([]);
  const [isOpen, toggleOpen] = useState(false);

  const { options = [], onSelect, hasDot, value, loading } = props;

  const renderTag = ({ value }) => value;

  const handleChange = ([currentLabel, clickedValue]) => {
    let newValue = [];

    if (selected.includes(clickedValue)) {
      newValue = selected.filter((value) => value !== clickedValue);

      if (newValue.length === options.length) {
        newValue = newValue.filter((value) => value !== 'all');
      }
      if (clickedValue === 'all' || newValue.length === 0) {
        newValue = [];
      }
    } else {
      newValue = [...selected, clickedValue];

      if (newValue.length === options.length || clickedValue === 'all') {
        newValue = getAllOptValue(options);
      }
    }

    //fix some issues when clickedValue is not actual value but undefined
    if (clickedValue === undefined && selected.length === 1) {
      newValue = [];
    }

    changeSelected(newValue);
    onSelect(newValue.filter((value) => value !== 'all'));
  };

  const handleDropdownOpen = (e) => {
    const target = e?.target;
    if (!target) {
      return;
    }
    if (!target.className || target.className.includes('selector')) {
      toggleOpen((state) => !state);
    }
  };

  const handleDropdownClose = () => {
    toggleOpen(false);
  };

  useEffect(() => {
    if (value === undefined) {
      return;
    }
    if (Array.isArray(value) && value.length === options.length) {
      return changeSelected(getAllOptValue(options));
    }

    changeSelected(value);
  }, [value]);

  return (
    <Select
      showArrow
      loading={loading}
      onClick={handleDropdownOpen}
      onBlur={handleDropdownClose}
      showSearch={false}
      open={isOpen}
      onChange={handleChange}
      className="dd-select dd-select-multiple"
      mode="multiple"
      value={getShowValue(selected, options)}
      tagRender={renderTag}
      dropdownClassName="dd-select-dropdown"
    >
      {renderOptions(options, selected, hasDot)}
    </Select>
  );
}

MulipleSelect.propTypes = {};

export default MulipleSelect;
